/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPixtaImageSuccessResponseData,
    GetPixtaImageSuccessResponseDataFromJSON,
    GetPixtaImageSuccessResponseDataFromJSONTyped,
    GetPixtaImageSuccessResponseDataToJSON,
} from './GetPixtaImageSuccessResponseData';

/**
 * GET /press_release/pixta/image
 * @export
 * @interface GetPixtaImageResponse
 */
export interface GetPixtaImageResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPixtaImageResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPixtaImageResponse
     */
    message: string;
    /**
     * 
     * @type {GetPixtaImageSuccessResponseData}
     * @memberof GetPixtaImageResponse
     */
    data: GetPixtaImageSuccessResponseData;
}

export function GetPixtaImageResponseFromJSON(json: any): GetPixtaImageResponse {
    return GetPixtaImageResponseFromJSONTyped(json, false);
}

export function GetPixtaImageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPixtaImageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetPixtaImageSuccessResponseDataFromJSON(json['data']),
    };
}

export function GetPixtaImageResponseToJSON(value?: GetPixtaImageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetPixtaImageSuccessResponseDataToJSON(value.data),
    };
}

